var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Syncing Availability",
        "modal-class": "channex-sync-availability",
        centered: "",
        "hide-footer": "",
        "no-close-on-esc": "",
      },
      model: {
        value: _vm.value_,
        callback: function ($$v) {
          _vm.value_ = $$v
        },
        expression: "value_",
      },
    },
    [
      _c(
        "div",
        { staticClass: "syncing-modal__content" },
        [
          _c(
            "b-form",
            [
              _c(
                "info-row",
                {
                  staticClass: "info-main-row syncing-unit-ids py-2",
                  attrs: { title: "Unit(s)", sizing: 3 },
                },
                [
                  _c("vue-multiselect", {
                    attrs: {
                      options: _vm.unitItems,
                      multiple: true,
                      "hide-selected": true,
                      "allow-empty": false,
                      disabled: !!_vm.form.id,
                      searchable: false,
                      label: "name",
                      "track-by": "id",
                    },
                    on: { select: _vm.onSelectUnit },
                    model: {
                      value: _vm.form.unit_ids,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "unit_ids", $$v)
                      },
                      expression: "form.unit_ids",
                    },
                  }),
                ],
                1
              ),
              _c(
                "info-row",
                {
                  staticClass: "info-main-row py-2",
                  attrs: { title: "Date From", sizing: 3 },
                },
                [
                  _c(
                    "b-input-group",
                    {
                      staticClass: "syncing-date",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.showDateFrom = !_vm.showDateFrom
                        },
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          value: _vm.formattedDateFrom,
                          state: _vm.fieldState.date_from,
                        },
                      }),
                      _c("b-input-group-append", { attrs: { "is-text": "" } }, [
                        _c("i", {
                          staticClass: "fi fi-calendar",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showDateFrom = !_vm.showDateFrom
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "date-picker--from" },
                    [
                      _vm.showDateFrom
                        ? _c("v-date-picker", {
                            staticClass: "syncing-date-picker inline",
                            attrs: {
                              value: _vm.form.date_from,
                              attributes: _vm.attrs,
                              "disabled-dates": _vm.disabledDates,
                              "disabled-attribute": _vm.disabledAttributes,
                              "show-day-popover": false,
                              mode: "single",
                              "is-inline": "",
                              "show-caps": "",
                            },
                            on: { input: _vm.onSelectDateFrom },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "info-row",
                {
                  staticClass: "info-main-row py-2",
                  attrs: { title: "Date To", sizing: 3 },
                },
                [
                  _c(
                    "b-input-group",
                    {
                      staticClass: "syncing-date",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.showDateTo = !_vm.showDateTo
                        },
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          value: _vm.formattedDateTo,
                          state: _vm.fieldState.date_to,
                        },
                      }),
                      _c("b-input-group-append", { attrs: { "is-text": "" } }, [
                        _c("i", {
                          staticClass: "fi fi-calendar",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showDateTo = !_vm.showDateTo
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "date-picker--to" },
                    [
                      _vm.showDateTo
                        ? _c("v-date-picker", {
                            staticClass: "syncing-date-picker inline",
                            attrs: {
                              value: _vm.form.date_to,
                              attributes: _vm.attrs,
                              "disabled-dates": _vm.disabledDates,
                              "disabled-attribute": _vm.disabledAttributes,
                              "show-day-popover": false,
                              mode: "single",
                              "is-inline": "",
                              "show-caps": "",
                            },
                            on: { input: _vm.onSelectDateTo },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("hr"),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { staticClass: "text-right px-2", attrs: { xs: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.onSyncAvailability },
                    },
                    [_vm._v("Send")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }